var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditionIsMessageReplied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3977 20.3248L22.1984 31.5988C22.0282 31.8328 22.0037 32.1425 22.135 32.4003C22.2663 32.6582 22.5312 32.8205 22.8205 32.8205H28.2051V39.2307C28.2051 39.5639 28.4196 39.8592 28.7364 39.9622C29.0533 40.0653 29.4004 39.9526 29.5964 39.6832L37.8015 28.4012C37.9717 28.1672 37.9962 27.8575 37.8649 27.5997C37.7336 27.3418 37.4687 27.1795 37.1794 27.1795H31.7948V20.7693C31.7948 20.754 31.7944 20.7388 31.7935 20.7237M30.4313 20.2808C30.4196 20.295 30.4084 20.3097 30.3977 20.3248L30.4313 20.2808ZM30.6765 20.0837C30.5843 20.1305 30.5005 20.1965 30.4313 20.2808L30.6765 20.0837ZM30.98 20.0014C30.8712 20.0077 30.7685 20.0367 30.6765 20.0837L30.98 20.0014ZM31.2636 20.0376C31.1712 20.0075 31.0749 19.9957 30.98 20.0014L31.2636 20.0376ZM31.5141 20.175C31.4407 20.1147 31.356 20.0676 31.2636 20.0376L31.5141 20.175ZM31.7112 20.4201C31.6644 20.328 31.5983 20.2442 31.5141 20.175L31.7112 20.4201ZM31.7935 20.7237C31.7871 20.6149 31.7582 20.5122 31.7112 20.4201L31.7935 20.7237ZM30.2564 23.1348L24.3311 31.282H28.9743C29.3991 31.282 29.7435 31.6264 29.7435 32.0513V36.8652L35.6688 28.718H31.0256C30.6008 28.718 30.2564 28.3736 30.2564 27.9487V23.1348Z",
    fill: "#091E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionIsMessageReplied);
export default __webpack_public_path__ + "static/media/condition_is_message_replied.8e4c5d02d68b4e6e069da3bceb351645.svg";
export { ForwardRef as ReactComponent };